import { createStyles } from '@material-ui/core/styles';
import Theme, { primaryColor } from '../../../theme';

const styles = (theme: any) => createStyles({
  contentWrap: {
    width: 720,
    // minHeight: 677,
    [theme.breakpoints.down(960)]: {
      width: '100%',
      maxWidth: '100%',
    },
  },
  content: {
    borderTop: '1px solid #cbcbcb',
    borderBottom: '1px solid #cbcbcb',
    paddingBottom: theme.spacing(5),
    [theme.breakpoints.only('xs')]: {
      paddingBottom: theme.spacing(3),
    },
    [theme.breakpoints.only('sm')]: {
      paddingBottom: theme.spacing(4),
    },
  },
  closeButton: {
    position: 'absolute',
    right: 12,
    top: 12,
  },
  titleWrap: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '20px',
  },
  actions: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down(960)]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(2),
      padding: theme.spacing(2),
    },
  },
  button: {
    width: 200,
    height: 52,
    marginLeft: `${theme.spacing(3)}px !important`,
    color: '#FFF',
    [theme.breakpoints.only('xs')]: {
      width: '100%',
      marginLeft: '0 !important',
      height: 40,
    },
    [theme.breakpoints.only('sm')]: {
      width: '100%',
      marginLeft: '0 !important',
      height: 44,
    },
    '&:disabled': {
      backgroundColor: primaryColor,
      color: 'rgba(255,255,255,0.5)',
    },
  },
  reject: {
    backgroundColor: theme.palette.buttonGrey.main,
    '&:hover': {
      backgroundColor: theme.palette.buttonGrey.hover,
    },
  },
  // mr22: {
  //   marginRight: 22,
  // },
  error: {
    color: Theme.palette.error.main,
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(3),
  },
});

export default styles;
